export type ExtractPathParams<T extends string> =
  T extends `${string}{${infer Param}}${infer Rest}`
    ? Param | ExtractPathParams<Rest>
    : never;

export function fillPathParams<T extends string>(
  template: T,
  params: Record<ExtractPathParams<T>, string | number>,
): string {
  return template.replace(/{(\w+)}/g, (_, key) => {
    const value = params[key as ExtractPathParams<T>];
    if (value === undefined) throw new Error(`Missing param: ${key}`);
    return String(value);
  });
}

export async function clearCart() {
  const response = await fetch('/api/storefront/cart');
  const data = await response.json();
  if (!data.length) return;
  fetch(`/api/storefront/carts/${data[0].id}`, { method: 'DELETE' }).then(() =>
    window.location.reload(),
  );
}

export function toQueryString(params: Record<string, any>): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, String(v)));
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, String(value));
    }
  });

  return searchParams.toString();
}
